import React, { useState } from 'react';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';

function OperationTypeForm({ initial, onSave, onCancel, loading }) {
  const [code, setCode] = useState(initial?.code || '');
  const [name, setName] = useState(initial?.name || '');
  const [description, setDescription] = useState(initial?.description || '');
  const [error, setError] = useState('');

  const locked = !!initial?.is_system_default;

  const validate = () => {
    if (!code.trim()) return 'Code is required.';
    if (!name.trim()) return 'Name is required.';
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({
      code: code.trim().toUpperCase(),
      name: name.trim(),
      description: description.trim(),
    });
  };

  return (
    <form className="operation-type-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
        <div>
          <label>Code<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            maxLength={10}
            placeholder="e.g., SPL"
            disabled={locked}
            style={{ width: 100 }}
          />
        </div>
        <div>
          <label>Name<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={100}
            placeholder="e.g., Split"
            disabled={locked}
          />
        </div>
      </div>

      {locked && (
        <div style={{ fontSize: 12, color: '#888', marginTop: 8 }}>
          This is a locked Operation Type — its code and name can't be changed.
        </div>
      )}

      <div style={{ marginTop: 14 }}>
        <label>Description</label><br />
        <textarea
          className="styled-input"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={2}
          style={{ width: '100%', maxWidth: 480, resize: 'vertical' }}
          placeholder="Optional notes on how this Operation Type is used"
        />
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default OperationTypeForm;
